// extracted by mini-css-extract-plugin
export default {"videoPlayer_div":"Step2_videoPlayer_div__VEEtQ"};